<app-topo [dadosCertificado]="dadosCertificado" [dadosRegistro]="dadosRegistro"></app-topo>

<app-nome-sistema [nomeSistema]="'RENOVAR REGISTRO'"></app-nome-sistema>


<div class="container jumbotron" *ngIf="dadosCertificado">

  <div class="row">
    <div class="col-lg-12 text-right" style="margin-top: -30px;">
      <app-botao-ajuda [manual]="'manual3_4'" [titleAjuda]="'Ajuda - Renovar registro'" [telaConsulta]="true">
      </app-botao-ajuda>
    </div>
  </div>

  <div class="row justify-content-md-left ">

    <div clas="col col-lg-8">

      <p class="titulo">Sr(a). usuário(a)</p>

      <p>Para a renovação do registro de seu certificado digital/token conectividade, favor selecionar um novo perfil.
      </p>

      <p>É de sua inteira responsabilidade informar o perfil adequado, bem como a utilização dos serviços habilitados.
      </p>

      <p>Selecione no combo abaixo um perfil diferente do atual <b> {{ dadosRegistro ? dadosRegistro.de_perfil : '' }}
        </b>.</p>

    </div>

  </div>

  <form [formGroup]="renovaForm" #psForm="ngForm">
    <app-seleciona-perfil *ngIf="dadosCertificado" (perfilSelecionadoEvent$)="atualizaPerfil($event)"
      [perfilAtual]="dadosRegistro">
    </app-seleciona-perfil>

    <div class="row justify-content-md-left">
      <div class="col-lg-8" *ngIf="mostraChecks">
        <section class="tp-section">
          <mat-checkbox class="example-margin" formControlName="chkRevogacao" color="primary"
            [disabled]="!isPerfilValido">
            <button class="textoNegrito" mat-button [disabled]="!isPerfilValido" (click)="lerTermoRevogacao()">
              Li e concordo com todas cláusulas e regras descritos nesse <b>Termo de Revogação</b>.
            </button>
          </mat-checkbox>
        </section>
      </div>
    </div>
    <div class="row justify-content-md-left">
      <div class="col-lg-8" *ngIf="mostraChecks">
        <section class="tp-section">
          <mat-checkbox class="example-margin" formControlName="chkContrato" color="primary"
            [disabled]="!isPerfilValido">
            <button class="textoNegrito" mat-button [disabled]="!isPerfilValido" (click)="lerContrato()">
              Li e concordo com todas cláusulas e regras descritos nesse <b>Contrato</b>.
            </button>
          </mat-checkbox>
        </section>
      </div>
    </div>
    <br /><br />
    <div mat-dialog-actions class="row justify-content-md-left botoes">
      <button mat-raised-button class="md-icon-button btnOK" [disabled]="habilitaBtn" *ngIf="mostraBtnRegistrar"
        (click)="renovar()" cdkFocusInitial>
        <img class="img-fluid" src="assets/icons/save_confirm.png" width="16px" /> Confirmar
      </button>
    </div>

    <div id="myDiv" #contrato hidden class="container"></div>

  </form>


</div>